<template>
  <div class="loader-wrapper">
    <div class="loader-container">
      <div class="spinner"></div>
      <span class="loader-text">
        {{ message }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    message: {
      type: String,
      default: "Loading..."
    }
  }
}
</script>

<style scoped>
.loader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  width: 100%;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* ✅ centers spinner + text horizontally */
}

.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid rgba(56, 189, 248, 0.3); /* light blue ring */
  border-top-color: #38bdf8; /* light blue highlight */
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 8px;
}

.loader-text {
  color: #38bdf8;
  font-size: 0.875rem;
  text-align: center; /* ✅ ensures text stays centered */
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
